import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { browserHistory } from 'react-router';
import Chip from 'material-ui/Chip';
import * as teamManagementActions from 'redux/modules/teamManagement';
import RaisedButton from 'material-ui/RaisedButton';
import { LeftNavLayout, PartnerAdjustmentForm } from 'containers';
import { ButtonBar, DataTable, NewUserDialog, PageHeader, Spinner } from 'components';
import { TeamFilterPanel } from 'components/Admin';
import * as styles from './Team.scss';
var Team = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    isLoadingTeamMembers: state.teamManagement.isLoadingTeamMembers,
    teamMembers: state.teamManagement.teamMembers,
    teamSortColumnKey: state.teamManagement.teamSortColumnKey,
    teamSortDirection: state.teamManagement.teamSortDirection,
    selectedStatus: state.teamManagement.teamListViewStatus,
    partnerDetails: state.teamManagement.partnerDetails
  };
}, _objectSpread({}, teamManagementActions)), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Team, _Component);

  var _super = _createSuper(Team);

  function Team(props) {
    var _this;

    _classCallCheck(this, Team);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleStatusSelection", function (tab) {
      _this.props.setTeamStatusSelection(tab.key);
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddTeamMemberClick", function () {
      if (_this.props.partnerDetails.totals.teamMembersRemaining > 0) {
        _this.setState({
          newUserDialogOpen: true
        });
      } else {
        // out of clients, must add more first
        console.log('out of team members');

        _this.setState({
          showAddTeamMemberDialog: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowSelection", function (selectedRows) {
      browserHistory.push({
        pathname: "/global/team/".concat(selectedRows.id)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchDidChange", function (query) {
      console.log("search for '".concat(query, "'"));
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearchValueChanged", _.debounce(_this.searchDidChange, 500));

    _this.state = {
      newUserDialogOpen: false,
      showAddTeamMemberDialog: false
    };
    return _this;
  }

  _createClass(Team, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getPartnerDetailsByPartnerOrgId(this.props.theme.org);
      this.props.getTeamMembers();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var contractInfo = this.props.partnerDetails;

      var inactiveFilter = function inactiveFilter(t) {
        var found = t.UserOrganizations.find(function (uo) {
          return parseInt(uo.OrganizationId, 10) === parseInt(_this2.props.theme.org, 10);
        });
        return found && found.status === 'INACTIVE';
      };

      var inactiveTeamMembers = this.props.teamMembers.filter(inactiveFilter);

      var activeTeamMembers = _.filter(this.props.teamMembers, _.negate(inactiveFilter));

      var teamMembers = this.props.selectedStatus === 'INACTIVE' ? inactiveTeamMembers : activeTeamMembers;
      var formattedTeamMembers = teamMembers.map(function (m) {
        return {
          name: /*#__PURE__*/React.createElement("div", null, "".concat(m.firstName, " ").concat(m.lastName), m.UserOrganizations && m.UserOrganizations.length && m.UserOrganizations[0].status === 'PENDING' ? /*#__PURE__*/React.createElement(Chip, {
            style: {
              display: 'inline-block',
              marginLeft: '5px',
              padding: '0px'
            }
          }, "Pending") : ''),
          createdAt: moment(m.createdAt).format('L'),
          email: m.email,
          id: m.id
        };
      });
      var headerFields = [{
        name: 'Name',
        key: 'name'
      }, {
        name: 'Email',
        key: 'email'
      }, {
        name: 'Start Date',
        key: 'createdAt'
      }];
      var tabs = [{
        title: 'Active',
        selected: true,
        key: 'ACTIVE'
      }, {
        title: 'Inactive',
        key: 'INACTIVE'
      }];

      if (this.props.selectedStatus === 'INACTIVE') {
        tabs = [{
          title: 'Active',
          key: 'ACTIVE'
        }, {
          title: 'Inactive',
          selected: true,
          key: 'INACTIVE'
        }];
      }

      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          padding: 36,
          overflow: 'auto'
        },
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Team Management"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Team Management"
      }), /*#__PURE__*/React.createElement("div", {
        onClick: this.handleAddTeamMemberClick,
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Add Team Member",
        style: {
          marginRight: 32
        }
      }), contractInfo && /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 12,
          marginTop: 8,
          marginRight: 32,
          textAlign: 'center'
        }
      }, "Using ", contractInfo.totals.teamMembersUsed, " of", ' ', contractInfo.totals.teamMembersPermitted, " team members."))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement(ButtonBar, {
        items: tabs,
        onChange: this.handleStatusSelection
      })), /*#__PURE__*/React.createElement(DataTable, {
        firstColColored: true,
        columnSort: {
          key: this.props.teamSortColumnKey,
          order: this.props.teamSortDirection.toLowerCase()
        },
        headerFields: headerFields,
        data: formattedTeamMembers,
        searchValueChanged: this.handleSearchValueChanged,
        fixedHeader: true,
        height: 500,
        isLoading: this.props.isLoadingTeamMembers,
        onRowSelection: function onRowSelection(selectedRows) {
          return _this2.handleRowSelection(selectedRows);
        }
      }), contractInfo && /*#__PURE__*/React.createElement(PartnerAdjustmentForm, {
        title: "Add More Team Members",
        show: this.state.showAddTeamMemberDialog,
        showTeamMemberField: true,
        showClientField: false,
        handleCloseAfterSubmit: function handleCloseAfterSubmit() {
          _this2.setState({
            showAddTeamMemberDialog: false,
            newUserDialogOpen: true
          });
        },
        handleClose: function handleClose() {
          _this2.setState({
            showAddTeamMemberDialog: false
          });
        }
      }), contractInfo && /*#__PURE__*/React.createElement(NewUserDialog, {
        userType: "Team Member",
        open: this.state.newUserDialogOpen,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            newUserDialogOpen: false
          });
        }
      }));
    }
  }]);

  return Team;
}(Component), _defineProperty(_class2, "propTypes", {
  theme: PropTypes.object,
  sendInvite: PropTypes.func.isRequired,
  sortTeamMembers: PropTypes.func.isRequired
}), _temp)) || _class);
export default Team;